import { endpoints } from 'Constants';

const categoryServices = {
	actives: (params) => ({
		baseURL: endpoints.CATEGORY.ACTIVES(params.businessId),
		method: 'GET',
	}),

	subCategories: (params) => ({
		baseURL: endpoints.CATEGORY.SUB_CATEGORIES(params.categoryId),
		method: 'GET',
	}),

	recommendedCategories: (params) => ({
		baseURL: endpoints.CATEGORY.RECOMMONED_COMMISION(params.categoryId),
		method: 'GET',
	}),

	dynamcAttributes: (params) => ({
		baseURL: endpoints.CATEGORY.DYNAMIC_ATTRIBUTES(params.categoryId),
		method: 'GET',
	}),

	tags: () => ({
		baseURL: endpoints.CATEGORY.TAGS(),
		method: 'GET',
	}),
};

export default categoryServices;
